import { useEffect, useState } from 'react';

export type AudioMixVolumes = {
  audioVolume: number;
  videoVolume: number;
};

export type UseVolumeDraftResult = {
  draft: AudioMixVolumes;
  onDrag: (volumes: AudioMixVolumes) => void;
  onCommit: (volumes: AudioMixVolumes) => void;
};

/**
 * Radix fires a change on every pointer move and every write to the post
 * triggers a save, so the drag is kept local and only committed on release.
 * The preview reads the draft, which is why it stays audible while dragging.
 */
export function useVolumeDraft(
  volumes: AudioMixVolumes,
  onChange: (volumes: AudioMixVolumes) => void,
): UseVolumeDraftResult {
  const [draft, setDraft] = useState(volumes);

  useEffect(() => {
    setDraft({
      audioVolume: volumes.audioVolume,
      videoVolume: volumes.videoVolume,
    });
  }, [volumes.audioVolume, volumes.videoVolume]);

  return {
    draft,
    onDrag: setDraft,
    onCommit: (next) => {
      setDraft(next);
      onChange(next);
    },
  };
}
